class VariantPicker extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.addEventListener('change', () => this.onChange());
  }
  onChange() {
    const selected = [...this.querySelectorAll('input[type=radio]:checked')].map(i => i.value);
    const match = this.variants.find(v => v.options.every((o, idx) => o === selected[idx])) || this.variants[0];
    const idInput = document.getElementById('variant-id');
    const btn = document.getElementById('add-to-cart');
    const price = document.getElementById('price-block');
    if (!match) return;
    idInput.value = match.id;
    btn.disabled = !match.available;
    btn.textContent = match.available ? window.__t.add : window.__t.sold;
    if (price) price.innerHTML = '<span class="price">' + (window.formatMoney ? window.formatMoney(match.price) : (match.price / 100).toFixed(2)) + '</span>';
    document.querySelector('[data-selling-plan-picker]')?.updateForVariant(match.id);
  }
}
customElements.define('variant-picker', VariantPicker);

class SellingPlanPicker {
  constructor(element) {
    this.element = element;
    this.input = element.querySelector('[data-selling-plan-input]');
    this.requiresPlan = element.dataset.requiresSellingPlan === 'true';
    this.allocations = JSON.parse(element.querySelector('[data-selling-plan-allocations]').textContent);
    element.addEventListener('change', (event) => {
      if (event.target.name === 'purchase_option') this.input.value = event.target.value;
    });
  }

  updateForVariant(variantId) {
    const allocations = this.allocations[String(variantId)] || [];
    const available = new Map(allocations.map((allocation) => [String(allocation.id), allocation]));

    this.element.querySelectorAll('[data-selling-plan-option]').forEach((option) => {
      const allocation = available.get(option.dataset.sellingPlanOption);
      option.classList.toggle('hidden', !allocation);
      option.querySelector('input').disabled = !allocation;
      const price = option.querySelector('[data-selling-plan-price]');
      if (price && allocation) price.firstChild.textContent = window.formatMoney(allocation.price) + ' ';
    });

    const selected = this.element.querySelector('input[name="purchase_option"]:checked');
    if (selected && (selected.value === '' || available.has(selected.value))) {
      this.input.value = selected.value;
      return;
    }

    const fallback = this.requiresPlan
      ? this.element.querySelector('[data-selling-plan-option]:not(.hidden) input')
      : this.element.querySelector('input[name="purchase_option"][value=""]');
    if (fallback) {
      fallback.checked = true;
      this.input.value = fallback.value;
    }
  }
}

document.querySelectorAll('[data-selling-plan-picker]').forEach((element) => {
  const picker = new SellingPlanPicker(element);
  element.updateForVariant = (variantId) => picker.updateForVariant(variantId);
});
